import { v4 as uuidv4 } from 'uuid';
import EnvStore from './env';
import ErrorsStore from './errors';
import AuthStore from './auth'; 
import AppClientStore from './appclient';
import LanguageStore from './language';
import SchedulesStore from './schedules';
import SubscriberStore from './subscriber';
import WidgetStore from './widget';
import UIStatesStore from './uistates';
import SyncStore from './sync';
import AppStore from './app';
import AnimationsStore from './animations';

export { useEnvStore } from './env';
export { useErrorsStore } from './errors';
export { useAuthStore } from './auth';
export { useAppClientStore } from './appclient';
export { useLanguageStore } from './language';
export { useSchedulesStore } from './schedules';
export { useSubscriberStore } from './subscriber';
export { useWidgetStore } from './widget';
export { useUIStatesStore } from './uistates';
export { useSyncStore } from './sync';
export { useAnimationsStore } from './animations';

window.env =  process.env.REACT_APP_ENV_VAR; // process.env.REACT_APP_ENV_VAR;  
window.SUBDOMAIN_API = process.env.REACT_APP_SUBDOMAIN_API;

if (process.env.REACT_APP_ENV_VAR === 'prod') {
    console.log = function () {};
}

//Setup Environment
const uniqueTraceId = uuidv4();
const envStore = new EnvStore();
envStore.Environment = window.env;
envStore.traceId = uniqueTraceId;

// setup other stores
const errorsStore = new ErrorsStore();
const authStore = new AuthStore();
const appClientStore  = new AppClientStore();
const languageStore = new LanguageStore();
const schedulesStore = new SchedulesStore();
const subscriberStore = new SubscriberStore();
const widgetStore = new WidgetStore();
const appStore = new AppStore();
const uiStatesStore = new UIStatesStore();
const syncStore = new SyncStore();
const  animationsStore = new AnimationsStore();

envStore.mountStores({
    errorsStore,
    authStore,
    appClientStore,
    languageStore,
    schedulesStore,
    subscriberStore,
    widgetStore,
    uiStatesStore,
    syncStore,
    appStore,
    animationsStore,
});

// to detach call envStore.unmountStores();

window.envStore = envStore;

const models = {
    envStore,
    errorsStore,
    authStore,
    appClientStore,
    languageStore,
    schedulesStore,
    subscriberStore,
    widgetStore,
    uiStatesStore,
    syncStore,
    appStore,
    animationsStore,
};

export default models;
